(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    class PrefabAccordion extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const singleOpen = this.dataset.singleOpen === 'true';
      const openFirst = this.dataset.openFirst === 'true';

      customElements.whenDefined('collapsible-content').then(() => {
        const collapsibleItems = Array.from(this.querySelectorAll('collapsible-content'));

        if (openFirst && collapsibleItems.length > 0) {
          collapsibleItems[0].openContent();
        }

        if (singleOpen) {
          collapsibleItems.forEach((item) => {
            item.toggleButton?.addEventListener('click', () => {
              collapsibleItems.forEach((otherItem) => {
                if (otherItem !== item) {
                  otherItem.closeContent();
                }
              });
            });
          });
        }
      });
    }
  }

  customElements.define('prefab-accordion', PrefabAccordion);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collapsible-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collapsible-content')) {
    class CollapsibleContent extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.toggleButton = this.querySelector('button');
        this.content = this.querySelector(`#${this.toggleButton.getAttribute('aria-controls')}`);

        this.toggleButton.addEventListener('click', () => {
          const isExpanded = this.toggleButton.getAttribute('aria-expanded') === 'true';

          if (isExpanded) {
            this.closeContent();
          } else {
            this.openContent();
          }
        });
      }

      openContent() {
        this.toggleButton.setAttribute('aria-expanded', 'true');
        this.content.setAttribute('aria-hidden', 'false');
      }

      closeContent() {
        this.toggleButton.setAttribute('aria-expanded', 'false');
        this.content.setAttribute('aria-hidden', 'true');
      }
    }

    customElements.define('collapsible-content', CollapsibleContent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-carousel"] && !Shopify.designMode) return;
  try {
    class ImageCarousel extends HTMLElement {
    connectedCallback() {
      const swiperEl = this.querySelector('.image-carousel');
      if (!swiperEl) return;

      new Swiper(swiperEl, {
        centeredSlides: true,
        loop: swiperEl.dataset.swiperLoop,
        enabled: swiperEl.dataset.swiperEnabled,
        autoHeight: swiperEl.dataset.swiperAutoHeight,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
        },
      });
    }
  }

  customElements.define('image-carousel', ImageCarousel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    class PrefabTabs extends HTMLElement {
    connectedCallback() {
      const buttons = this.querySelectorAll('[data-tab-button]');
      const panels = this.querySelectorAll('[data-tab-panel]');

      // Show first panel, hide the rest
      panels.forEach((panel, index) => {
        panel.classList.toggle('hidden', index !== 0);
        if (buttons[index]) {
          buttons[index].innerText = panel.dataset.tabLabel;
        }
      });

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const tabId = button.dataset.tabButton;

          // Update buttons
          buttons.forEach((btn) => {
            btn.setAttribute('aria-selected', btn.dataset.tabButton === tabId);
          });

          // Update panels
          panels.forEach((panel) => {
            panel.classList.toggle('hidden', panel.dataset.tabPanel !== tabId);
          });
        });
      });
    }
  }

  customElements.define('prefab-tabs', PrefabTabs);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["testimonials"] && !Shopify.designMode) return;
  try {
    class TestimonialsBlock extends HTMLElement {
    connectedCallback() {
      if (this.swiper) return;

      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        autoHeight: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 300,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector('[data-swiper-next]'),
          prevEl: this.querySelector('[data-swiper-prev]'),
        },
      });
    }

    disconnectedCallback() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  if (!customElements.get('testimonials-block')) {
    customElements.define('testimonials-block', TestimonialsBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
